import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { AmendmentTypes, ChangeTaskTypes } from '@xemplo/gp-types';
import { useListBuilder } from '@xemplo/stateful-list-core';
import { V2 } from '@xemplo/text-dropdown';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

export function RecurringType() {
  const { control, getValues } = useFormContext<FormFields>();
  const changeType = getValues('changeType');
  const changeTask = useWatch({ control, name: 'changeTask' });

  const showRecurringType = useMemo(
    () =>
      changeType === AmendmentTypes.RECURRING &&
      validRecurringChangeTaskTypes.includes(changeTask),

    [changeTask, changeType],
  );

  const recurringTypeList = useListBuilder(RecurringTypeOptions);

  if (!showRecurringType) return null;
  return (
    <S.FormLabel>
      Recurring type
      <V2.TextDropdownRhf
        items={recurringTypeList}
        name="recurringType"
        placeholder="Select type"
        data-testid="recurringType"
        aria-label="Recurring type field"
        rules={{
          required: 'This field is required',
        }}
      />
    </S.FormLabel>
  );
}

export const RecurringTypeValues = {
  MAXIMUM_AMOUNT: 1,
  END_DATE: 2,
} as const;

export const RecurringTypeOptions = [
  { key: RecurringTypeValues.MAXIMUM_AMOUNT, value: 'Maximum Amount' },
  { key: RecurringTypeValues.END_DATE, value: 'End Date' },
];

const validRecurringChangeTaskTypes = [
  ChangeTaskTypes.ALLOWANCE,
  ChangeTaskTypes.DEDUCTION,
  ChangeTaskTypes.SALARY,
];
